import { ICommunicationError } from "@dev/hc-talk-talk";
import AuthorizationKeyRequest from "@/app/dto/AuthorizationKeyRequest";
import FactorEnum from "@/app/dto/FactorEnum";
import IAllowedFactorsResponse from "@/app/dto/IAllowedFactorsResponse";
import IPhoneNumber from "@/app/dto/IPhoneNumber";
import OtpRequest from "@/app/dto/OtpRequest";
import ProcessEnum from "@/app/dto/ProcessEnum";
import Property from "@/app/dto/Property";
import ApiError from "@/app/model/ApiError";
import KeyResult from "@/app/model/KeyResult";
import OtpResult from "@/app/model/OtpResult";
import Api from "@/app/service/api";

class Authorization {
    public getAllowedFactorsExternal(customerUuid: string, process: ProcessEnum): Promise<IAllowedFactorsResponse> {
        return new Promise((resolve, reject) => {
            Api.getAllowedFactorsExternal(customerUuid, process)
                .then((response: any) => {
                    resolve(response);
                })
                .catch((error: ICommunicationError) => {
                    reject(new ApiError(error));
                });
        });
    }

    public authorizationKeyExternal(customerUuid: string, factors: FactorEnum[], sendOtp: boolean, process: ProcessEnum): Promise<KeyResult> {
        return new Promise((resolve, reject) => {
            Api.authorizationKeyExternal(customerUuid, new AuthorizationKeyRequest(factors, sendOtp), process)
                .then((response: any) => {
                    resolve(new KeyResult(response));
                })
                .catch((error: ICommunicationError) => {
                    resolve(new KeyResult(undefined, new ApiError(error)));
                });
        });
    }

    public sendOtpExternal(customerUuid: string, authorizationKey: string, process: ProcessEnum): Promise<OtpResult> {
        return new Promise((resolve, reject) => {
            Api.sendOtpExternal(customerUuid, authorizationKey, process)
                .then((response: any) => {
                    resolve(new OtpResult(response));
                })
                .catch((error: ICommunicationError) => {
                    resolve(new OtpResult(undefined, new ApiError(error)));
                });
        });
    }

    public getAllowedFactorsProtected(token: string, process: ProcessEnum): Promise<IAllowedFactorsResponse> {
        return new Promise((resolve, reject) => {
            Api.getAllowedFactorsProtected(token, process)
                .then((response: any) => {
                    resolve(response);
                })
                .catch((error: ICommunicationError) => {
                    reject(new ApiError(error));
                });
        });
    }

    public authorizationKeyProtected(token: string,
                                     factors: FactorEnum[],
                                     sendOtp: boolean,
                                     process: ProcessEnum,
                                     mobile?: IPhoneNumber,
                                     data?: Property[]): Promise<KeyResult> {
        return new Promise((resolve, reject) => {
            Api.authorizationKeyProtected(token, new AuthorizationKeyRequest(factors, sendOtp, mobile, data), process)
                .then((response: any) => {
                    resolve(new KeyResult(response));
                })
                .catch((error: ICommunicationError) => {
                    resolve(new KeyResult(undefined, new ApiError(error)));
                });
        });
    }

    public sendOtpProtected(token: string,
                            authorizationKey: string,
                            process: ProcessEnum,
                            mobile?: IPhoneNumber,
                            data?: Property[]): Promise<OtpResult> {
        return new Promise((resolve, reject) => {
            Api.sendOtpProtected(token, authorizationKey, new OtpRequest(mobile, data), process)
                .then((response: any) => {
                    resolve(new OtpResult(response));
                })
                .catch((error: ICommunicationError) => {
                    resolve(new OtpResult(undefined, new ApiError(error)));
                });
        });
    }
}

export default new Authorization();
